import HeroData from '../Data/hero'

function Hero() {
    return (
        <>
        {HeroData.map((Hero) => (
            <div className="w-full h-screen flex flex-col">
                <div className="w-full flex-shrink pt-10 pb-20">
                    <div className="flex xl:flex-row flex-col justify-between w-full gap-20">
                        <div className=" md:text-8xl text-5xl font-mono">{Hero.title}</div>
                        <div className=" md:text-3xl text-xl font-mono max-w-4xl">
                            {Hero.desc}
                        </div>
                    </div>
                </div>
                <div className="w-full flex-grow bg-white rounded-3xl">
                    <video src="./video/mmg-video-main.mp4" autoplay="true" loop="true" muted="true" className="w-full h-full rounded-3xl object-cover" />
                </div>
            </div>
        ))}
        </>
    )
}

export default Hero;